import React from 'react';
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { ArrowRight, Calendar } from 'lucide-react';
import { useArticles } from '../../hooks/useShopify'; // New hook
import { Link } from 'react-router-dom';

const Inspiration = () => {
  const { articles, loading, error } = useArticles();

  if (error) return null; // Gracefully degrade if blog posts fail

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-4">
          <div className="max-w-2xl">
            <span className="text-accent font-semibold tracking-wider text-sm uppercase mb-2 block">Grønne tips</span>
            <h2 className="text-4xl font-serif font-bold text-primary mb-4">Tips & Inspirasjon</h2>
            <p className="text-muted-foreground text-lg">
              Bli inspirert og lær mer om frødyrking, såing og hageglede.
            </p>
          </div>
          <Link to="/category/alle" className="hidden md:flex">
            <Button variant="outline">
              Se alle artikler <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {loading ? (
            // Skeleton Loading
            Array.from({ length: 3 }).map((_, i) => (
               <div key={i} className="flex flex-col space-y-3">
                 <Skeleton className="h-[200px] w-full rounded-2xl" />
                 <div className="space-y-2">
                   <Skeleton className="h-4 w-3/4" />
                   <Skeleton className="h-4 w-full" />
                   <Skeleton className="h-4 w-1/2" />
                 </div>
               </div>
            ))
          ) : (
            // Data Loaded
            articles.map((article) => (
              <Link key={article.id} to={`/article/${article.id}`} className="group cursor-pointer flex flex-col h-full">
                <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[16/10]">
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors z-10" />
                  <img 
                    src={article.image} 
                    alt={article.title} 
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col flex-grow">
                  <div className="flex items-center gap-2 text-sm text-accent font-medium mb-3">
                    <Calendar className="h-4 w-4" />
                    <span>{article.date}</span>
                  </div>
                  <h3 className="text-2xl font-serif font-bold text-foreground mb-3 group-hover:text-primary transition-colors leading-tight">
                    {article.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed mb-4 flex-grow">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center text-primary font-semibold group-hover:translate-x-2 transition-transform duration-300">
                    Les mer <ArrowRight className="ml-2 h-4 w-4" />
                  </span>
                </div>
              </Link>
            ))
          )}
        </div>
        
         <div className="mt-10 text-center md:hidden">
            <Link to="/category/alle">
                <Button variant="outline" className="w-full">Se alle artikler</Button>
            </Link>
        </div>
      </div>
    </section>
  );
};

export default Inspiration;
